import { Translate } from 'react-redux-i18n'
import { formatVal, valToPercent } from '../../../helpers/value'
import { EMPTY_VALUE } from '../../../utils/common'
import BaseCell from './BaseCell'
import NumberCompanyCell from './NumberCompanyCell'
import {
  COLUMN_IDS,
  CREDIT_RISK_COL,
  TITLE_TABLE_SCORE_TREND,
} from './constant'

const {
  STT,
  PERCENT_OF_TOTAL_COMPANIES,
  NUMBER_OF_COMPANIES,
  LOCATION_NAME,
  CREDIT_RISK_SCORE,
  PERFORMANCE_SCORE,
} = COLUMN_IDS

export const getSchema = (isCreditScore, isDynamicReport) => {
  const schema = [...TITLE_TABLE_SCORE_TREND]
  if (isDynamicReport) schema.push(CREDIT_RISK_COL)

  return schema.map((item, index, arr) => {
    const isPerformanceColumn = index === arr.length - 1 && !isCreditScore
    const colId = isPerformanceColumn ? PERFORMANCE_SCORE : item.key

    return {
      colId,
      title: handleTHeadTitle(isPerformanceColumn, item, isDynamicReport),
      isI18n: true,
      sortable: ![STT, LOCATION_NAME].includes(colId) && !isDynamicReport,
      thStyle: item.thStyle,
      tdStyle: {
        ...item.tdStyle,
        minWidth:
          isDynamicReport && item.key !== COLUMN_IDS.STT
            ? 120
            : item.tdStyle.minWidth,
      },
      renderTh:
        isDynamicReport && item.isChangeTitle
          ? () => (
              <div className="textEnd">
                <Translate
                  value={handleTHeadTitle(
                    isPerformanceColumn,
                    item,
                    isDynamicReport,
                  )}
                  dangerousHTML={true}
                />
              </div>
            )
          : undefined,
      render: (val, { rowIndex, locale, ...other }) => {
        return (
          {
            [STT]: rowIndex + 1,
            [NUMBER_OF_COMPANIES]: (
              <NumberCompanyCell
                isDynamicReport={isDynamicReport}
                val={val}
                {...other}
              />
            ),
            [PERCENT_OF_TOTAL_COMPANIES]: valToPercent(val, locale),
            [CREDIT_RISK_SCORE]: (
              <BaseCell val={val} locale={locale} {...other} />
            ),
            [PERFORMANCE_SCORE]: (
              <BaseCell val={val} locale={locale} {...other} />
            ),
          }[colId] ?? val
        )
      },
    }
  })
}

export const handleTHeadTitle = (
  isPerformanceColumn,
  item,
  isDynamicReport,
) => {
  const title = isPerformanceColumn
    ? 'portfolio.segment.PERFORMANCE_SCORE'
    : item.title

  return isDynamicReport && item.isChangeTitle ? `${title}_DYNAMIC` : title
}

export const getIds = (payload) => {
  if (!payload.length) return []

  const clonePayload = structuredClone(payload)
  return clonePayload
    .sort((a, b) => b.numberCompanies - a.numberCompanies)
    .map((item) => item.locationId)
}

export const handleBaseCellValue = (val, locale) => {
  if (typeof val !== 'number' || isNaN(val)) return EMPTY_VALUE

  if (Number.isInteger(val)) return val

  return formatVal(val, locale, undefined, 1)
}
